import * as Middleware from "@middlewares/index";

interface ShowAlertProps {
  text: string;
  status?: "success" | "danger";
}

export const showAlert = async ({ text, status }: ShowAlertProps) => {
  let ProgressAlert: any;

  Middleware.Ui.Alert.open("Process", {
    text,
    component: (c: any) => {
      ProgressAlert = c;
    },
  });

  setTimeout(() => {
    if (ProgressAlert) {
      status && ProgressAlert.setStatus(status);
      ProgressAlert.startTimer(5000);
    }
  }, 0); // Ждем следующего тика Event Loop, против бага в самом Process setStatus
};
